<div class="container-fluid header-container">
    <div class="header">
        <div class="left-info">
            <h1 class="title" style="display: flex; align-items: center;">
                <fa-icon class="back-icon" [icon]="faChevronLeft"></fa-icon>
                <span (click)="goBack()" style="cursor: pointer;">
                    {{ 
                        client 
                        ? (
                            clientType.value === 'PHYSICAL_PERSON'
                                ? 
                                    (client.firstSurname ? client.firstSurname + ' ' : '') +
                                    (client.secondSurname ? client.secondSurname + ', ' : '') +
                                    (client.name ? client.name : '')
                                : 
                                    (client.name ? client.name : '')
                        ) 
                        : 'Nuevo Cliente' 
                    }}
                </span>
            </h1>
            <span 
                class="tag" 
                *ngIf="clientType" 
                [ngClass]="{
                    'juridic-person-tag': clientType.value === 'JURIDIC_PERSON',
                    'physical-person-tag': clientType.value === 'PHYSICAL_PERSON'
                }"
            >
                {{ clientType.label }}
            </span>
            <div class="relation-dropdown" *ngIf="relationType() && relationType()?.value">
                <button type="button"
                    class="relation-pill tag"
                    [class.recurrent-tag]="relationType().value === 'RECURRENT'"
                    [class.no-recurrent-tag]="relationType().value === 'NO_RECURRENT'"
                    [class.no-client-tag]="relationType().value === 'NO_CLIENT'"
                    (click)="toggleRelationMenu()">
                    {{ relationType().label }}
                    <span class="relation-chevron" [class.open]="relationMenuOpen()"></span>
                </button>
                <ul class="relation-menu" 
                    [class.is-open]="relationMenuOpen()" 
                    [attr.aria-hidden]="!relationMenuOpen()">
                    @for (type of relationTypes; track type.value) {
                        <li>
                            <button type="button"
                                class="relation-option"
                                [class.is-active]="type.value === relationType().value"
                                (click)="selectRelationType(type.value)">
                                {{ type.label }}
                            </button>
                        </li>
                    }
                </ul>
            </div>
            <span *ngIf="client && clientState()"
                class="tag state-tag"
                [ngClass]="{
                    'active': clientState() === 'ACTIVE',
                    'inactive': clientState() === 'INACTIVE',
                    'pending': clientState() === 'PENDING'
                }"
            >
                <fa-icon [icon]="faCircle"></fa-icon>
                @if(clientState() === 'ACTIVE') {
                    @if(client.reactivationDate) {
                        Activo: {{ client.reactivationDate | date:'dd/MM/yyyy' }}
                    } @else if(client.created_at) {
                        Activo: {{ client.created_at | date:'dd/MM/yyyy' }}
                    } @else {
                        Activo
                    }
                } @else if(clientState() === 'INACTIVE') {
                    @if(client.endDate) {
                        Inactivo: {{ client.endDate | date:'dd/MM/yyyy' }}
                    } @else {
                        Inactivo
                    }
                } @else if(clientState() === 'PENDING') {
                    Pendiente
                } @else {
                    {{ clientState() }}
                }
            </span>
        </div>
        <div class="nav-buttons">
            <button *ngIf="client && clientState() !== 'PENDING'" class="button historico-btn" (click)="toggleHistorico()" aria-label="Ver histórico de cambios" [class.is-active]="drawerOpen()">
                <fa-icon [icon]="faClockRotateLeft"></fa-icon>
                <span class="historico-btn-label">Histórico</span>
            </button>
            <button *ngIf="client" class="button is-secondary next-button" (click)="goToNext()">
                Siguiente cliente 
                    <fa-icon class="next-icon" [icon]="faArrowRight"></fa-icon>
            </button>
        </div>
    </div>
    <nav class="tabs" aria-label="Secciones del cliente">
        <ul>
            @for (tab of tabs(); track tab.title) {
            <li [class.is-active]="tab.isActive">
                <button type="button" class="tab-link"
                    [disabled]="!enabledTabs && !tab.isActive"
                    [attr.aria-current]="tab.isActive ? 'page' : null"
                    (click)="changeTab(tab)">
                    {{tab.title}}
                    <fa-icon *ngIf="tab.hasAlert" class="tab-alert" [icon]="faTriangleExclamation" title="El certificado digital ha caducado"></fa-icon>
                </button>
            </li>
            }
        </ul>
    </nav>
</div>

@if (snapshotDate()) {
    <div class="snapshot-banner" role="status">
        <div class="snapshot-banner-inner">
            <fa-icon [icon]="faClockRotateLeft" aria-hidden="true"></fa-icon>
            <span class="snapshot-text">Viendo estado del cliente a fecha: <strong class="snapshot-date">{{ snapshotDate() | date:'dd/MM/yyyy' }}</strong></span>
            <button class="snapshot-back-btn" (click)="clearSnapshot()">
                <fa-icon [icon]="faClockRotateLeft" aria-hidden="true"></fa-icon>
                Volver a estado actual
            </button>
        </div>
    </div>
}

<div class="container-fluid content-page">
    <div class="tab-content" [class.is-snapshot]="snapshotDate()">
        @if(!isLoading) {
            @switch (getActiveTab()?.key) {
                <!-- Pestañas comunes -->
                @case("identification") {
                    <app-identification-form #activeForm [clientId]="clientId" [hasEditPermission]="hasEditPermission" [relationType]="relationType()?.value" [activeTab]="getActiveTab()?.key" [snapshotData]="snapshotData()?.client ?? null" [snapshotDocuments]="snapshotData()?.client_document ?? null" [snapshotRelatedPersons]="snapshotData()?.client_related_person ?? null" (createEvent)="onClientCreated($event)" (formIsDirty)="showButton = true" (stateChange)="updateClientState($event)"></app-identification-form>
                }
                @case("fiscalData") {
                    <app-fiscal-data-form #activeForm [clientId]="clientId" [clientType]="clientType?.value" [snapshotData]="snapshotData()?.client_fiscal_data ?? null" (formIsDirty)="showButton = true" (certificateExpired)="onCertificateExpired($event)"></app-fiscal-data-form>
                }
                @case("otherData") {
                    <app-other-data-form #activeForm [clientId]="clientId" [hasEditPermission]="hasEditPermission" [snapshotData]="snapshotData()?.client_bank_account ?? null" (formIsDirty)="showButton = true"></app-other-data-form>
                }
                @case("workTeam") {
                    <app-work-team-form #activeForm [clientId]="clientId" [snapshotData]="snapshotData()?.client_work_team ?? null" (formIsDirty)="showButton = true"></app-work-team-form>
                }
                
                <!-- Pestañas específicas Persona Física -->
                @case("addresses") {
                    <app-addresses-form #activeForm [clientId]="clientId" [snapshotData]="snapshotData()?.client_address ?? null" (formIsDirty)="showButton = true"></app-addresses-form>
                }
                
                <!-- Pestañas adicionales Persona Física Recurrente -->
                @case("laborData") {
                    <app-labor-data-form #activeForm [clientId]="clientId" [snapshotData]="snapshotData()?.client_labor ?? null" (formIsDirty)="showButton = true"></app-labor-data-form>
                }
                @case("activities") {
                    <app-activities-form #activeForm [clientId]="clientId" [clientType]="clientType" [snapshotData]="snapshotData()?.client_activity ?? null" (formIsDirty)="showButton = true"></app-activities-form>
                }
                @case("contacts") {
                    <app-contacts-form #activeForm [clientId]="clientId" [snapshotData]="snapshotData()?.client_contact ?? null" [snapshotUsers]="snapshotData()?.contact_user ?? null" (formIsDirty)="showButton = true"></app-contacts-form>
                }
                @case("constitution") {
                    <app-constitution-form #activeForm [clientId]="clientId" [activeTab]="getActiveTab()?.key" (formIsDirty)="showButton = true"></app-constitution-form>
                }
                @case("operacionesSocietarias") {
                    <app-operaciones-societarias-form #activeForm [clientId]="clientId" [snapshotDate]="snapshotDate()"></app-operaciones-societarias-form>
                }
                <!-- Libros (Persona Física) -->
                @case("books") {
                    <app-books-form #activeForm [clientId]="clientId" [clientType]="clientType?.value" [snapshotData]="snapshotData()?.client_book ?? null" (formIsDirty)="showButton = true"></app-books-form>
                }
                
                <!-- Declaraciones -->
                @case("declarations") {
                    <app-declarations-form #activeForm [clientId]="clientId" [hasEditPermission]="hasEditPermission" [snapshotData]="snapshotData()?.client_application ?? null" (formIsDirty)="showButton = true"></app-declarations-form>
                }

                

            }
        } @else {
            <div class="column is-12" style="display: flex; justify-content: center; margin-top: 100px;">
                <p-progressSpinner ariaLabel="loading"
                styleClass="custom-spinner"/>        </div>
        }
    </div>
</div>
<!-- @if(showButton) {
    <div class="save-button-container">
        <button class="button save-button" (click)="saveTab()"><fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar</button>
    </div>

} -->
<app-historico-drawer
    [open]="drawerOpen()"
    [clientId]="clientId"
    [snapshotDate]="snapshotDate()"
    (close)="drawerOpen.set(false)"
    (dateSelected)="snapshotDate.set($event)"
></app-historico-drawer>

@if (isSaved) {
    <div class="notification is-success">
        <!-- <button class="delete" (click)="isSaved = false"></button> -->
        <div class="notification-text">
            Guardado correctamente.
        </div>
        <div class="progress-bar-container">

        <progress class="progress is-small" min="0" max="100" #progressBar></progress>
        </div>
    </div>
}
